import { isNewAnalyticsEnabled } from "../../services/AnalyticsReadAPI";

export default function AnalyticsModeNotice({ error }) {
  if (!isNewAnalyticsEnabled || !error) return null;
  return (
    <p role="alert">Analytics could not be loaded. {error.response?.data?.error?.message || error.message || "Please try again."}</p>
  );
}
